import { observable, action } from "mobx";
import { createContext, useContext } from "react";
import { IWorkorder } from "../models/workorder";
import agent from "../api/agent";
import { IWorkOrderSOR } from "../models/workordersor";
import { INote } from "../models/note";
import { IVariation } from "../models/variation";
import { Iappointments } from "../models/appointments";
import Powerbi from "../../features/workorders/dashboard/Powerbi";


class DashboardStore{

    @observable loadinginital = false;
    
    @action LoadPowerBi = () => {
        this.loadinginital = true;
        
        
    }

}

export default createContext (new DashboardStore);